import { ApiTypes } from "types"

import { ModalLayout } from "layouts/ModalLayout"

import styles from "./index.module.scss"

interface ActiveAlertRulesModalProps {
  device: ApiTypes.Model.Device
  alertRuleNames: string[]
  onClose: () => void
}

export const ActiveAlertRulesModal = ({ device, alertRuleNames, onClose }: ActiveAlertRulesModalProps) => {
  return (
    <ModalLayout width="540px" isWithoutFooter onClose={onClose} className={styles.activeAlertRulesModal}>
      <h2 className={styles.activeAlertRulesTitle}>Active Alert Rules</h2>
      <div className={styles.activeAlertRulesMeta}>
        <div>
          <div className={styles.activeAlertRulesLabel}>SERIAL NUMBER</div>
          <div>{device.sn}</div>
        </div>
        <div>
          <div className={styles.activeAlertRulesLabel}>ALERTS SENT TO</div>
          <div>{device.email || "-"}</div>
        </div>
      </div>
      <div className={styles.activeAlertRulesList}>
        {alertRuleNames.map(alertRuleName => (
          <div className={styles.activeAlertRulesListItem} key={alertRuleName}>
            {alertRuleName}
          </div>
        ))}
      </div>
    </ModalLayout>
  )
}
